import React from "react"
import { Field } from "redux-form";
import { renderInput } from "../../../commons";

export const PointOfSaleAdvancedSettings = () => (
    <>
        <Field name="businessDetails.openingDate" type="date" component={renderInput} title="Date d'ouverture" />
    </>
);